import { render, staticRenderFns } from "./OtherReport.vue?vue&type=template&id=67658514&scoped=true&"
import script from "./OtherReport.vue?vue&type=script&lang=js&"
export * from "./OtherReport.vue?vue&type=script&lang=js&"
import style0 from "./OtherReport.vue?vue&type=style&index=0&id=67658514&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67658514",
  null
  
)

export default component.exports